import { formatDistanceToNow } from 'date-fns'
import { tr } from 'date-fns/locale'
import Button from '../ui/Button'
import type { AutoSaveStatus } from './useAutoSaveForm'

interface Props {
  title: string
  subtitle?: string
  status: AutoSaveStatus
  savedAt: Date | null
  error?: string | null
  onUndo?: () => void
}

export default function FormHeader({ title, subtitle, status, savedAt, error, onUndo }: Props) {
  return (
    <div className="flex items-start justify-between mb-4 gap-4">
      <div className="min-w-0">
        <h1 className="text-lg font-semibold text-[var(--color-text)] truncate">{title}</h1>
        {subtitle && <p className="text-sm text-[var(--color-text-muted)]">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3 text-xs text-[var(--color-text-muted)] shrink-0">
        <StatusIndicator status={status} savedAt={savedAt} error={error} />
        {onUndo && (
          <Button variant="ghost" size="sm" onClick={onUndo}>
            Geri al
          </Button>
        )}
      </div>
    </div>
  )
}

function StatusIndicator({
  status,
  savedAt,
  error,
}: {
  status: AutoSaveStatus
  savedAt: Date | null
  error?: string | null
}) {
  if (status === 'dirty') {
    return <span className="text-yellow-500">Kaydedilmemiş değişiklikler</span>
  }
  if (status === 'saving') {
    return <span className="text-yellow-500">Kaydediliyor...</span>
  }
  if (status === 'error') {
    return <span className="text-red-500">{error || 'Kaydedilemedi'}</span>
  }
  if (status === 'saved' && savedAt) {
    const rel = formatDistanceToNow(savedAt, { locale: tr, addSuffix: true })
    return <span className="text-green-500">Kaydedildi {rel}</span>
  }
  return null
}
